import Moment from 'moment';
import { useEffect } from 'react';
import { useState } from 'react';

const EmployeeHolidayNode = ({ cssname, holliday, t, index}) => {
    
    const [statustext, setstatustext] = useState(t('requested'));
    const [stylesheet, setstylesheet] = useState("requested");
    
        useEffect(() => {

            if (holliday.status === 0 || holliday.status === 1) {
                setstylesheet("requested")
                setstatustext( t('underrevision'))
            } else if (holliday.status === 1) {
                setstylesheet("approvedsup")
                setstatustext( t('pre-approved'))
            } else if (holliday.status === 2) {
                setstylesheet("approved")
                setstatustext(  t('approved'))
            } else if (holliday.status === 3) {
                setstylesheet("rejected")
                setstatustext( t('rejected'))
            }
    
        }, [holliday]);

    return (
        <div id={holliday.id + "_holliday"} className={index % 2 === 0 ? "linkVarient1Holiday_view" : "linkVarient2Holiday_view"}  >
            <p>{Moment(holliday.startdatum).format('DD MMM YY')}</p>
            <p>{Moment(holliday.einddatum).format('DD MMM YY')}</p>
            <p>{holliday.reden}</p>
            <p className={stylesheet}>{statustext}</p>
        </div>
    )
}

export default EmployeeHolidayNode;